import { createReducer } from 'redux-act';

import {
  LOGS_FETCH_DATA_INIT,
  LOGS_FETCH_DATA_SUCCESS,
  LOGS_FETCH_DATA_FAIL,
  LOGS_EXPORT_LOG_INIT,
  LOGS_EXPORT_LOG_SUCCESS,
  LOGS_EXPORT_LOG_FAIL,
  LOGS_CLEAN_UP,
} from 'state/actions/log';

const initialState = {
  list: [],
  loading: false,
  error: null,
  deleted: false,
  downloading: false,
};

export const logsReducer = createReducer(
  {
    [LOGS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [LOGS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      loading: false,
      error: null,
    }),
    [LOGS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [LOGS_EXPORT_LOG_INIT]: (state) => ({
      ...state,
      downloading: true,
    }),
    [LOGS_EXPORT_LOG_SUCCESS]: (state) => ({
      ...state,
      downloading: false,
    }),
    [LOGS_EXPORT_LOG_FAIL]: (state) => ({
      ...state,
      downloading: false,
    }),
    [LOGS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
    }),
  },
  initialState
);
